import React, { useState, useEffect } from 'react'
import { Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  message,
} from 'antd'
import {
  Div, Button, H4, Input, H5, P,
} from 'konsys-ui'
import history from '../../history'
import PATH from '../../constants/path'
import VALIDATE from '../../constants/validate'
import Container from '../../components/container'
import ReturnPage from '../../components/common/return-page'
import { theme, screenSize } from '../../styles/_variables'
import { FORGET_PASSWORD } from '../../constants/graph/mutation'
import Banner from '../../images/member/banner.jpg'
import { WidthContainer, CenterContainer } from './styled'
import { getAccessToken } from '../../utils/local-data-service'

const EmailSend = () => (
  <Div margin='32px 0'>
    <ReturnPage
      title='ลืมรหัสผ่าน'
      buttonData={[{
        link: PATH.home,
        title: 'กลับสู่หน้าแรก',
        style: 'inverse',
      }]}
    >
      <P style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>ระบบได้ทำการส่ง Email สำหรับการตั้งรหัสผ่านใหม่ ไปยัง Email ของคุณแล้ว</P><br></br>
      <P style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>กรุณายืนยันการตั้งรหัสผ่านใหม่จาก Link ภายใน Email ที่คุณได้รับ</P>
    </ReturnPage>
  </Div>
)

const ForgetPassword = () => {
  const [email, setEmail] = useState()
  const [send, setSend] = useState(false)
  const [windowSize, setWindowSize] = useState(window.innerWidth)

  const doMutation = (func) => {
    func({
      variables: {
        email,
      },
    }).then((resp) => {
      if (resp.data.forgetPassword.success) {
        setSend(true)
      } else {
        message.error(resp.data.forgetPassword.message)
      }
    })
  }

  useEffect(() => {
    if (getAccessToken()) {
      history.push(PATH.home)
    }
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth)
    })
  })

  const isTabletS = windowSize <= screenSize.tabletS

  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'บัญชีผู้ใช้',
        color: theme.color.tertiaryColor,
      }}
    >
      <WidthContainer>
        {
          send
            ? <EmailSend/>
            : <CenterContainer>
            <Div textAlign='left' width='210px'>
              <H4 margin='0 0 16px' color={theme.color.tertiaryColor}>ลืมรหัสผ่าน</H4>
            </Div>
            <Mutation
              mutation={FORGET_PASSWORD}
            >
            {doForgetPassword => (
              <Div>
                <Div margin='24px 0' display='flex' justifyContent='center'>
                  <Div display='flex' flexDirection='column'>
                    <H5 margin='0 0 8px' color={theme.color.primaryColor}>Email ของคุณ</H5>
                    <Input
                      onChange={e => setEmail(e.target.value)}
                      width={isTabletS && '100%'}
                      onKeyPress={(e) => {
                        if (e.charCode === 13) {
                          doMutation(doForgetPassword)
                        }
                      }}
                    />
                  </Div>
                </Div>
                <Div margin='8px 0 0' display='flex' justifyContent='center'>
                  <Button
                    disabled={_.isUndefined(email) || !VALIDATE.email.test(email)}
                    margin='0 8px'
                    inverse
                    buttonStyle="round"
                    color={theme.color.secondaryColor}
                    text='รีเซ็ตรหัสผ่าน'
                    onClick={() => {
                      doMutation(doForgetPassword)
                    }}
                  />
                </Div>
              </Div>
            )}
            </Mutation>
          </CenterContainer>
        }
      </WidthContainer>
    </Container>
  )
}

export default ForgetPassword



// WEBPACK FOOTER //
// ./src/pages/forget-password/index.jsx